export const odluka_vrtic = {
    templateId: 239,
    category: 4,
    templateTitle: "Odluka o isplati naknade troškova redovne skrbi djece radnika u ustanovama predškolskog odgoja",
    templateDescription: `<p>Poslodavac može radniku isplatiti naknadu troškova redovne skrbi njegove djece u ustanovama predškolskog odgoja, a za to je dužan imati vjerodostojnu dokumentaciju - vlastitu odluku i dokumentaciju ustanove predškolskog odgoja (ugovor/uplatnica i sl.).</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>

    <p>Neoporezivim primicima smatraju se troškovi redovne skrbi djece radnika u ustanovama predškolskog odgoja.</p>
    <p>Redovnom skrbi djece ne smatraju se dodatni programi koji se posebno naplaćuju. </p>
    <p>Naknada se isplaćuje na temelju odluke poslodavca o isplati naknade i vjerodostojne dokumentacije ustanova predškolskog odgoja (uplatnica i/ili ugovor koji može glasiti i na dijete).</p>
    <p>Poslodavac ima obvezu zadržati kopiju vjerodostojne dokumentacije u svojoj poslovnoj dokumentaciji. </p>
    <p>Ako poslodavci svakog od roditelja djeteta snose dio ili cijeli nastali trošak, radnik je dužan o tome obavijestiti poslodavca.</p>
    <p><strong>U tom smislu, radnik kojemu poslodavac isplaćuje naknadu za trošak redovne skrbi djece obavezan je poslodavcu prije isplate dostaviti izjavu da nitko drugi već ne koristi pravo na naknadu ovog troška te kopiju računa odnosno izjavu da li su navedeni primici već isplaćeni za isto razdoblje od strane drugog poslodavca.</strong></p>
    <p>Ako su navedeni primici već isplaćeni za isto razdoblje od strane drugog poslodavca, no djelomično,  poslodavac može neoporezivo isplatiti samo iznos do visine stvarnih izdataka.</p>
    <p>Radi pokrića prethodno navedenog, izrađen je i primjerak izjave radnika kojom izjavljuje koristi li drugi roditelj pravo na naknadu ovog troška, koji možete vidjeti <a class="local-link" href="/contract?template=239.1">ovdje</a>.</p>
    <p>U slučaju da dođe do promjena troška redovne skrbi djeteta radnika ili ako radniku više ne nastaje trošak po toj osnovi, radnik je obavezan o istom obavijestiti poslodavca, a prema primjeru obavijesti <a class="local-link" href="/contract?template=239.2">ovdje</a>.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o porezu na dohodak, Pravilnik o porezu na dohodak.</p>
  `,
    sides: [
        {
            prefix: 'Na temelju Zakona o porezu na dohodak i Pravilnika o porezu na dohodak,',
            signature: 'Za Poslodavca:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
              suffix: ' (u daljnjem tekstu: Poslodavac),',
        }
    ],

    headline: 'donosi sljedeću',
    title: 'ODLUKA O NAKNADI TROŠKOVA REDOVNE SKRBI DJECE RADNIKA U USTANOVAMA PREDŠKOLSKOG ODGOJA',
    noArticleNumbers: true,

    articles: [

        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    choices: [
                        {
                            parts: [
                              { type: "text", content: "Ovom Odlukom uređuje se pravo radnika na naknadu troškova redovne skrbi djece radnika u ustanovama predškolskog odgoja (u daljnjem tekstu: Naknada)." },
                            ]
                            },
                        {
                            parts: [
                              { type: "text", content: "Ovom Odlukom uređuje se pravo radnika" },
                              { type: 'input', value: '', required: true, placeholder: "Ime i prezime", },
                              { type: "text", content: "," },
                              { type: 'text', content: 'iz' },
                              { type: 'input', value: '', required: true,placeholder: "Mjesto", },
                              { type: 'text', content: ',' },
                              { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj", },
                              { type: 'text', content: ',' },
                              { type: 'text', content: 'OIB:' },
                              { type: "input",  required: true,},
                              { type: "text", content: ", (dalje u tekstu: Radnik) na naknadu troškova redovne skrbi djece radnika u ustanovama predškolskog odgoja (u daljnjem tekstu: Naknada)." },
                              ]
      }],
      value: '',
      }
      ]
      },
      {
        title: '',
        mandatory: true,
        statements: [
            {
                type: 'choice',
                mandatory: true,
                choices: [
                    {
                        parts: [
                          { type: "text", content: "Naknada iz ove Odluke isplaćuje se do visine stvarnih izdataka." },
                        ]
                        },
                    {
                        parts: [
                          { type: "text", content: "Naknada iz ove Odluke se isplaćuje se u iznosu od" },
                          { type: 'input', value: '', required: true, placeholder: "Unesite iznos.", },
                          { type: "text", content: "kn,  ali ne više od stvarnih izdataka." },
               
                          ]
  }],
  value: '',
  }
  ]
  },
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    editable: true,
                    mandatory: true,
                    content: 'Radnik kojemu Poslodavac isplaćuje naknadu za trošak redovne skrbi djece obavezan je Poslodavcu prije isplate dostaviti izjavu da nitko drugi već ne koristi pravo na naknadu po istoj osnovi te dostaviti i kopiju računa.\r\nAko poslodavci svakog od roditelja djeteta snose dio ili cijeli nastali trošak, radnik je dužan o tome obavijestiti Poslodavca.',
                    value: '',
                }],
        },
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    editable: true,
                    mandatory: true,
                    content: 'Naknada iz ove Odluke neće se isplatiti radniku koji u cijelosti ostvaruje pravo na naknadu troškova redovne skrbi djeteta u ustanovama predškolskog odgoja kod drugog poslodavca. \r\nU slučaju da radnik ostvaruje kod drugog poslodavca pravo na naknadu dijela troška redovne skrbi djece, ali ne do punog iznosa stvarnih izdataka, Poslodavac će mu isplatiti naknadu troškova smještaja u skladu s ovom Odlukom, no nikako ne veću od visine stvarnih izdataka.',
                    value: '',
                }],
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: true,
                    choices: [
                        'Naknada iz ove Odluke  isplaćuje se na račun radnika, do 15-og u mjesecu, za prethodni mjesec, a na temelju vjerodostojne dokumentacije (kopija računa).',
                        'Naknada iz ove Odluke  isplaćuje se na račun radnika, do 15-og u mjesecu, za tekući mjesec, a na temelju vjerodostojne dokumentacije  (kopija računa).'
                    ],
                    placeholder: "Odaberite ovdje te potom izmijenite po želji...",
                }
            ]
        },
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    editable: true,
                    mandatory: true,
                    content: 'Naknada iz ove Odluke isplaćuje se na redovan račun radnika.',
                    value: '',
                }],
        },
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Odluka se primjenjuje s danom donošenja.',
                    value: '',
                }],
        },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
        {
            static: true,
            mandatory: false,
            type: 4, 
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Dostaviti:\r\n1) Radniku\r\n2) Kadrovska služba \r\n3) Obračun plaća',
                    help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
                }
            ]
        },
    ],
};
        


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/239_odluka_vrtic.ts